




























































































import Vue from "vue";
import SensitivityLabel from "@/components/SensitivityLabel.vue";
import { computed, ref } from "@vue/composition-api";

export default Vue.extend({
  props: ["item", "can_teach", "hide_levels"],
  components: {
    SensitivityLabel,
  },
  setup(props) {
    const borderLeftColor = computed(() => {
      const levels = {
        None: "var(--primary)",
        Low: "var(--level-l)",
        Medium: "var(--level-m)",
        High: "var(--level-h)",
      };
      // @ts-ignore
      return levels[props.item.sensitivity];
    });

    const show_full_desc = ref(false);

    return { borderLeftColor, show_full_desc };
  },
});
